/**
 * Trigger: tr_accounts_soft_delete
 * Purpose: Cascade soft delete and update positions when an account is soft deleted
 * Table: accounts
 * Event: UPDATE OF is_deleted
 */
export const TR_ACCOUNTS_SOFT_DELETE = `
CREATE TRIGGER tr_accounts_soft_delete
UPDATE OF is_deleted ON accounts
BEGIN
  UPDATE account_activity_dates
  SET is_deleted = new.is_deleted
  WHERE account_id = old._id;

  UPDATE account_daily_balances
  SET is_deleted = new.is_deleted
  WHERE account_id = old._id;

  UPDATE account_balances
  SET is_deleted = new.is_deleted
  WHERE account_id = old._id;

  UPDATE account_transfers
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM account_transfers),
      updated_at = strftime('%s', 'now')
  WHERE (account_in_id = old._id OR account_out_id = old._id)
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE creditors
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM creditors),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE debtors
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM debtors),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE exchanges
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM exchanges),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE incomes
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM incomes),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE expenses
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM expenses),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE planned_expenses
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM planned_expenses),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE planned_incomes
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM planned_incomes),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE account_initial_balances
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM account_initial_balances),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE creditor_payments
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM creditor_payments),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE debtor_payments
  SET is_deleted = (SELECT max(is_deleted) + 1 FROM debtor_payments),
      updated_at = strftime('%s', 'now')
  WHERE account_id = old._id
    AND new.is_deleted <> 0
    AND is_deleted = 0;

  UPDATE accounts
  SET position = position - 1,
      updated_at = strftime('%s', 'now')
  WHERE new.is_deleted <> 0
    AND position > old.position
    AND is_deleted = 0;
END;
`;
